import type { ColumnsType } from 'antd/es/table';
import { Button, Space, Popconfirm, Tag } from 'antd';

export interface SignupUsersData {
  userId: number;
  username: string;
  name: string;
  email: string;
  birthDate: string;
  phone: string;
  workplace: string;
  medicalLicenseNumber: string | null;
  specialistNumber: string | null;
  department: string | null;
  position: string | null;
  isSpecialist: boolean | null; // null: 입력 전 가입자
  createdAt: string;
}

const empty = <span style={{ color: '#bbb' }}>-</span>;

// 전문의 여부 + 번호 (승인 목록 / 상세에서 같이 쓴다)
export const renderSpecialist = (record: Pick<SignupUsersData, 'isSpecialist' | 'specialistNumber'>) => {
  if (record.isSpecialist === true) {
    return (
      <span>
        <Tag color="blue">전문의</Tag>
        {record.specialistNumber || <span style={{ color: '#bbb' }}>번호 미입력</span>}
      </span>
    );
  }
  if (record.isSpecialist === false) return <span style={{ color: '#888' }}>아니오</span>;
  return empty;
};

export const getSignupColumns = (
  onApprove: (userId: number) => void,
  onReject: (userId: number) => void,
  onDetail: (record: SignupUsersData) => void,
): ColumnsType<SignupUsersData> => [
  {
    title: 'ID',
    dataIndex: 'username',
    key: 'username',
    width: 120,
  },
  {
    title: '이름',
    dataIndex: 'name',
    key: 'name',
    width: 90,
  },
  {
    title: '소속',
    dataIndex: 'workplace',
    key: 'workplace',
    ellipsis: true,
  },
  {
    title: '소속과',
    dataIndex: 'department',
    key: 'department',
    width: 110,
    ellipsis: true,
    render: (v: string | null) => v || empty,
  },
  {
    title: '직위',
    dataIndex: 'position',
    key: 'position',
    width: 100,
    ellipsis: true,
    render: (v: string | null) => v || empty,
  },
  {
    title: '면허번호',
    dataIndex: 'medicalLicenseNumber',
    key: 'medicalLicenseNumber',
    width: 110,
    render: (v: string | null) =>
      v ? v : <span style={{ color: '#bbb' }}>없음</span>,
  },
  {
    title: '전문의',
    key: 'specialist',
    width: 150,
    render: (_, record) => renderSpecialist(record),
  },
  {
    title: '이메일',
    dataIndex: 'email',
    key: 'email',
    ellipsis: true,
  },
  {
    title: '휴대폰',
    dataIndex: 'phone',
    key: 'phone',
    width: 130,
  },
  {
    title: '신청일',
    dataIndex: 'createdAt',
    key: 'createdAt',
    width: 110,
    render: (createdAt: string) => createdAt?.substring(0, 10) ?? '-',
  },
  {
    title: '관리',
    key: 'action',
    align: 'center',
    fixed: 'right',
    width: 220,
    render: (_, record) => (
      <Space size="small">
        <Button onClick={() => onDetail(record)}>상세</Button>
        <Button
          type="primary"
          onClick={() => onApprove(record.userId)}
        >
          승인
        </Button>
        <Popconfirm
          title="가입 거절"
          description="정말 거절하시겠습니까?"
          onConfirm={() => onReject(record.userId)}
          okText="예"
          cancelText="아니오"
        >
          <Button type="primary" danger>거절</Button>
        </Popconfirm>
      </Space>
    ),
  },
];